import { defineComponent as _defineComponent } from 'vue'
import {ProposalsPlan} from "@/models/store/proposal";
import {computed} from "vue";
import EstimatedTimeLeft from "@/components/commons/EstimatedTimeLeft.vue";
import EstimatedUpgradeDate from "@/components/commons/EstimatedUpgradeDate.vue";
import {useConfigurationStore} from "../../store/configuration.store";
import {useBlockStore} from "@/store/block.store";



export default /*#__PURE__*/_defineComponent({
  __name: 'ProposalSoftwareUpgrade',
  props: {
    proposalPlan: { type: Object, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props;

const alreadyDone = computed(() => {
  if (props.proposalPlan?.height) {
    return Number(props.proposalPlan?.height) - useBlockStore().getLatestBlock.height < 0;
  }
  return false;
});

const getLink = (link: string) => {
  return "<a href=" + link + " target='_blank'>" + link + "</a>";
};

const __returned__ = { props, alreadyDone, getLink, EstimatedTimeLeft, EstimatedUpgradeDate, get useConfigurationStore() { return useConfigurationStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})